import { render, staticRenderFns } from "./DropdownPage.vue?vue&type=template&id=b80ee378&scoped=true&"
import script from "./DropdownPage.vue?vue&type=script&lang=js&"
export * from "./DropdownPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ee378",
  null
  
)

export default component.exports